module.exports = "/assets/data/5b91def55e6a24163feedd0ac5ef0335-BT5.data.json";